import { render, staticRenderFns } from "./im_content.vue?vue&type=template&id=0c5138d7&scoped=true&"
import script from "./im_content.vue?vue&type=script&lang=ts&"
export * from "./im_content.vue?vue&type=script&lang=ts&"
import style0 from "./im_content.vue?vue&type=style&index=0&id=0c5138d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5138d7",
  null
  
)

export default component.exports